import React, { FC } from 'react';
import { SearchCommentary } from './searchResultComment.types';
import { CommentarySubtitle } from '../../../../commentary/components/subtitle/CommentarySubtitle';

type Props = {
  comment: SearchCommentary;
};

export const SearchResultCommentarySubtitle: FC<Props> = ({ comment }) => {
  const items: Array<{ label: string; highlight?: boolean }> = [];
  if (comment.author) {
    items.push({ label: comment.author, highlight: true });
  }
  if (comment.niceSource) {
    items.push({ label: comment.niceSource, highlight: true });
  }
  if (comment.date) {
    items.push({ label: comment.date });
  }
  if (comment.score) {
    items.push({ label: String(comment.score) });
  }

  return <CommentarySubtitle items={items} />;
};
